<template>
    <b-card>
        <b-row class="mb-3">
            <b-col lg="3">
                <b-btn variant="success" @click="previousWeek()">
                    <i class="fa fa-arrow-left"></i> Previous Week
                </b-btn>
            </b-col>
            <b-col lg="6" class="text-center">
                <h3>{{ range.start_date }} - {{ range.end_date }}</h3>
            </b-col>
            <b-col lg="3" class="text-right">
                <b-btn variant="success" @click="nextWeek()" :disabled="isCurrentWeek">
                    Next Week <i class="fa fa-arrow-right"></i>
                </b-btn>
            </b-col>
        </b-row>

        <loading-card v-if="busy"></loading-card>
        <div v-else class="table-responsive">
            <b-table bordered striped hover show-empty
                     :items="shifts"
                     :fields="fields"
            >
                <template v-slot:cell(client)="data">
                    <strong v-if="data.value == 'TOTAL'">TOTAL</strong>
                    <span v-else>{{ data.value }}</span>
                </template>
            </b-table>
        </div>
    </b-card>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';

    export default {
        props: {
            caregiver: {
                type: Object,
                default: {},
            },
        },

        mixins: [FormatsDates, FormatsNumbers],

        data() {
            return {
                range: {start_date: '', end_date: ''},
                shifts: [],
                busy: true,
                fields: [
                    {
                        key: 'client',
                        label: 'Claimant',
                        sortable: true,
                    },
                    {
                        key: 'date',
                        label: 'Date',
                        sortable: true
                    },
                    {
                        key: 'rate',
                        label: 'Rate',
                        formatter: (value) => { return value ? this.moneyFormat(value) : '' },
                        sortable: true
                    },
                    {
                        key: 'duration',
                        label: 'Hours',
                        sortable: true
                    },
                    {
                        key: 'earnings',
                        label: 'Earnings',
                        formatter: (value) => { return this.moneyFormat(value) },
                        sortable: true
                    },
                ]
            }
        },
        
        computed: {
            currentWeek() {
                return {
                    start_date: moment().startOf('week').format('MM/DD/YYYY'),
                    end_date: moment().endOf('week').format('MM/DD/YYYY'),
                }
            },

            isCurrentWeek() {
                return this.currentWeek.start_date == this.range.start_date &&
                    this.currentWeek.end_date == this.range.end_date;
            },
        },

        created() {
            this.updateRange(this.currentWeek);
        },

        methods: {
            previousWeek() {
                this.updateRange({
                    start_date: moment(this.range.start_date, 'MM/DD/YYYY').subtract({days: 7}).format('MM/DD/YYYY'),
                    end_date: moment(this.range.end_date, 'MM/DD/YYYY').subtract({days: 7}).format('MM/DD/YYYY'),
                });
            },

            nextWeek() {
                this.updateRange({
                    start_date: moment(this.range.start_date, 'MM/DD/YYYY').add({days: 7}).format('MM/DD/YYYY'),
                    end_date: moment(this.range.end_date, 'MM/DD/YYYY').add({days: 7}).format('MM/DD/YYYY'),
                });
            },

            updateRange(range) {
                this.range = range;
                this.busy = true;

                axios.post('/caregiver/invoices/report', this.range)
                    .then( ({data}) => {
                        this.shifts = data.shifts.map(shift => {
                            return {
                                client: shift.client.name,
                                date: this.formatDateFromUTC(shift.checked_in_time),
                                duration: shift.duration,
                                rate: shift.caregiver_rate,
                                earnings: shift.total,
                            }
                        });

                        if (this.shifts.length) {
                            this.shifts.push({
                                ...data.totals,
                                client: 'TOTAL',
                                rate: '',
                                date: '',
                            });
                        }

                        this.totalRows = this.shifts.length;
                        this.busy = false;
                    })
                    .catch(e => {
                        this.shifts = [];
                        this.totalRows = 0;
                        this.busy = false;
                    });
                },
        },
    }
</script>
